import PropTypes from 'prop-types'
import React from 'react'
import styled, { theme } from '@nobia/zeus-components/lib/styled'

import { useTranslation } from '../../utils/useTranslation'

const Wrapper = styled.div`
  display: flex;
  min-width: 68px;
  margin-top: 10px;
`
const Left = styled.div`
  background-color: ${theme('colors.toneA')};
  border: 1px solid #d1d3d4;
  border-radius: 3px;
  transform: rotate(45deg) translateX(10px) translateY(-5px);
  height: 20px;
  width: 20px;
  border-top: none;
  border-right: none;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 3px;
`
const Right = styled.div`
  background-color: ${theme('colors.toneA')};
  border: 1px solid #d1d3d4;
  border-radius: 1.5px 3px 3px 1.5px;
  padding: 3px;
  padding-left: 4px;
  border-left: none;
  height: 27px;
`
const Pound = styled.strong`
  display: inline-block;
  opacity: ${p => (p.filled ? 0.3 : 1)};
  font-size: 15px;
  margin: 0 1px;
  transform: translateY(-0.5px);
`
const Dot = styled.div`
  border-radius: 50%;
  border: 1px solid #d1d3d4;
  background-color: ${theme('colors.white')};
  width: 7px;
  height: 7px;
`

const priceBands = [1, 2, 3]

const PriceBand = ({ count }) => {
  const { t } = useTranslation()
  return (
    <Wrapper>
      <Left>
        <Dot />
      </Left>
      <Right>
        {priceBands.map(x => (
          <Pound key={x} filled={count < x}>
            {t('app.components.price-band.currency')}
          </Pound>
        ))}
      </Right>
    </Wrapper>
  )
}

PriceBand.propTypes = {
  count: PropTypes.number.isRequired,
}

export default PriceBand
